__turbopack_context__.v({
  "accordion": "ArchiveExpand-module-scss-module__8rpBSa__accordion",
  "accordion_body": "ArchiveExpand-module-scss-module__8rpBSa__accordion_body",
  "accordion_body_item": "ArchiveExpand-module-scss-module__8rpBSa__accordion_body_item",
  "accordion_body_item_active": "ArchiveExpand-module-scss-module__8rpBSa__accordion_body_item_active",
  "accordion_summary": "ArchiveExpand-module-scss-module__8rpBSa__accordion_summary",
  "accordion_summary_box": "ArchiveExpand-module-scss-module__8rpBSa__accordion_summary_box",
  "accordion_title": "ArchiveExpand-module-scss-module__8rpBSa__accordion_title",
});
